module.exports = __webpack_public_path__ + "img/Halt-H.9840ff7a.svg";